import React from 'react';

function PrivacyPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
      <div className="prose max-w-none text-gray-600">
        <p>Your privacy is important to us. This policy explains how we collect, use, and protect your information.</p>
        <h2 className="text-xl font-bold text-gray-900 mt-6 mb-2">Information We Collect</h2>
        <p>We collect information you provide directly, such as name, email, and artwork details.</p>
        <h2 className="text-xl font-bold text-gray-900 mt-6 mb-2">How We Use Information</h2>
        <p>We use your information to provide our services, process transactions, and communicate with you.</p>
        <h2 className="text-xl font-bold text-gray-900 mt-6 mb-2">Contact</h2>
        <p>For privacy concerns, contact us at contact@chitrakalakar.com</p>
      </div>
    </div>
  );
}

export default PrivacyPage;
